<template>
  <div class="
    flex
    justify-between
    w-full
    h-fit
    min-h-full
  ">
    <div class="
      flex
      flex-col
      justify-between
      w-full
    ">
      <div>
        <img
          alt="Logo"
          class="
            mt-12
            w-full
            h-6
            md:mt-10
            md:ml-10
            md:w-[120px]
            md:h-auto
            lg:ml-10
            lg:mt-10
            lg:w-[120px]
            lg:h-auto
          "
          src="@/assets/images/logo-inverted.svg"
        />
        <div class="
          flex
          flex-col
          justify-center
          items-center
          mt-10
          mb-16
          md:mt-20
          lg:mt-20
        ">
          <div class="mb-9">
            <h1 class="mb-4 text-black font-light text-[32px]">
              登入
              <span class="font-medium">
                好彙訂
              </span>
            </h1>
            <p class="text-center">
              沒有帳戶？
              <router-link class="no-underline text-blue-500" to="/register">
                立即註冊
              </router-link>
            </p>
          </div>
          <login-form />
        </div>
      </div>
      <p class="mb-6 text-gray-500 text-center text-sm">
        Copyright © {{ currentYear }} 微碧愛普科技有限公司. 保留一切權利。
      </p>
    </div>
    <div class="
      hidden
      px-10
      py-6
      w-[260px]
      h-auto
      bg-[#F1F4FF]
      md:flex
      md:flex-col
      md:justify-between
      md:w-[35%]
      md:min-w-[35%]
      lg:flex
      lg:flex-col
      lg:justify-between
      lg:w-[35%]
      lg:min-w-[35%]
    ">
      <div class="flex flex-col flex-1 justify-center items-center">
        <img src="@/assets/images/login-right-1.svg" class="mb-16">
        <img
          alt="登入好彙訂"
          src="@/assets/images/login-image.svg"
        />
      </div>
      <div class="text-right text-black text-sm">
        <a
          alt="使用條款"
          href="https://www.takeorder.tw/terms-of-service"
          target="_blank"
        >
          使用條款
        </a>
        <a
          alt="隱私權政策"
          href="https://www.takeorder.tw/privacy-and-policy"
          target="_blank"
        >
          隱私權政策
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Login from './Login';

export default Login;
</script>

<style lang="scss" scoped>
@import 'Login';
</style>
